<modal-open-point id="confirmar-checkout-modal-1">
  <div normal>
    <confirmar-checkout-modal></confirmar-checkout-modal>
  </div>
</modal-open-point>
<div normal>
  <modal-default-mmaxapp>
    <div normal>
      <modal-default-mmaxapp>
        <div class="wrapper-calendar">
          <div class="titulo">Seleccione un dia de entrega:</div>
          <!-- Cabecera del calendario -->
          <div class="header-calendar">
            <div>
              <button (click)="changeMonth(-1)" class="btn-prev">Antes</button>
            </div>
            <h1 style="text-transform: uppercase;">{{dateSelect.format('MMMM YYYY')}}</h1>
            <div>
              <button (click)="changeMonth(1)" class="btn-next">Siguiente</button>
            </div>
          </div>
        
          <!-- Días de la semana -->
          <ol class="weekdays">
            <li *ngFor="let day of week" class="day-name">{{day | slice:0:3}}</li>
          </ol>
        
          <!-- Días del mes -->
          <ol class="days">
            <li *ngFor="let day of monthSelect; let first = first" 
                (click)="clickDay(day)" 
                [class.today]="day.isToday" 
                [class.disabled]="day.isDisabled" 
                [class.selected]="day.isSelected" 
                [style.gridColumnStart]="first ? day?.indexWeek : 'auto'">
              <span>{{day?.value}}</span>
            </li>
          </ol>
        </div>
        
        <hr>
        <div class="titulo2">
          Fecha seleccionada: {{dateValue | date}}
        </div>
        <div class="btns">
          <div>
          <button class="button" (click)="cancelar()">Cancelar</button>
        </div>
        <div>
          <button class="button" (click)="confirmarAgenda()">Confirmar</button>
        </div>
        </div>
        
      </modal-default-mmaxapp>
    </div>
    
  </modal-default-mmaxapp>
</div>